<template>
<div class="chapter">
<div class="inner_page">
<div id="outpfm1">
<div class="generated-style">
<p class="basic-paragraph" xml:lang="en-us"></p>
<p class="basic-paragraph basic-paragraph-override" xml:lang="en-us"><span class="generated-style"><img alt="Outlaws with Badges display type.tif" class="generated-style" src="Images/OutlawswithBadgesd_fmt1.jpeg"/></span></p>
</div>
<p class="basic-paragraph basic-paragraph-override" xml:lang="en-us"><span class="generated-style"><img alt="PELOGO.TIF" class="generated-style" src="Images/PELOGO_fmt.jpeg"/></span></p>
<p class="basic-paragraph basic-paragraph-override" xml:lang="en-us"><span class="no-style-override-3">PELICAN PUBLISHING COMPANY</span></p>
<p class="basic-paragraph basic-paragraph-override" xml:lang="en-us"><span class="no-style-override-4">Gretna 2013</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?10f56a1f